var metaService = require("../../../services/metaService.js");
var common = require("../../../utiles/common.js");
var c = require("../../../utiles/entranceConfig");
var loginUtils = require("../LoginUtils");
var cp = require("../newCpLogin");
require("./KingFa.less");

module.exports = {
  register: function () {
    document.createElement("kf-login-tab");
    ko.components.register("kf-login-tab", {
      viewModel: function (params) {
        var $this = this;
        $this.entrance = c.entrance;
        $this.qrcode = ko.observable("");
        $this.ajaxUrl = ko.observable("");
        $this.loginActive = ko.observable("user");
        $this.enabled = ko.observable();
        $this.userList = ko.observableArray();
        $this.tenantErrorMessage = ko.observable();
        $this.isVerifyCodeVisible = ko.observable(false);
        $this.verifyCodeType = ko.observable("PWD_LOGIN");
        var authNode = localStorage.getItem("authNode");
        var designatedTenant = false;
        if (authNode) {
          designatedTenant = JSON.parse(authNode).designatedTenant;
        }
        $this.tenant = designatedTenant;
        $this.loginEntrance = ko.observable(loginUtils.getLoginEntrance());
        $this.forgetPasswordEnable = ko.observable(false);
        $this.getQR = function () {
          var QRS = [];
          for (var key in $this.loginEntrance()) {
            if (key.indexOf("WECOM_QR") > -1) {
              QRS.push(key);
            }
          }
          return QRS;
        };
        $this.QRS = ko.observable($this.getQR());
        $this.loginMethod = ko.observable(
          loginUtils.getPriorityMax($this.loginEntrance())
        );
        console.log($this.loginEntrance());
        // 客户端设置
        metaService.setClientId();
        // 取loginEntrance下的verifyCodeType
        $this.setVerifyCodeType = function () {
          if ($this.loginEntrance()[$this.loginMethod()]) {
            $this.verifyCodeType(
              $this.loginEntrance()[$this.loginMethod()].verifyCodeType
            );
            $this.isVerifyCodeVisible(
              common.fetch("/auth/verification/need", {
                type: "GET",
                query: {
                  type: $this.verifyCodeType() ? $this.verifyCodeType() : null,
                },
              }).data
            );
          }
        };
        $this.setVerifyCodeType();

        common.fetch("/auth/getLoginAction", {
          type: "GET",
          success: function (result) {
            console.log(result);
            $this.loginAction = result.data;
          },
        });
        //忘记密码判断
        common.fetch("/auth/portal/config/getPortalConfig", {
          type: "GET",
          success: function (result) {
            console.log(result);
            if (result.data) {
              $this.forgetPasswordEnable(
                result.data.forgetPasswordEnable ? true : false
              );
            }
          },
        });

        $this.errorMessage = ko.observable("");
        $this.keypress = function (keyCode) {
          if (keyCode == 13) {
            $this.login();
          }
        };
        $this.userKeypress = function (keyCode) {
          if (keyCode == 13) {
            $("input[type=password]").focus();
          }
        };
        $this.userBlur = function (e) {
          var tenant = $(".pwdLogin input").serializeObject().tenant;
          common.fetch(
            "/auth/tenant/set?tenantPrefix=" + (tenant ? tenant : ""),
            {
              type: "GET",
              error: function (error) {
                if (error.responseText) {
                  $this.tenantErrorMessage(
                    JSON.parse(error.responseText).message.split(":")[1] +
                      ":" +
                      tenant
                  );
                }
                console.log(error.responseText);
              },
              success: function (result) {
                console.log(result);
                $this.tenantErrorMessage("");
                $this.loginEntrance(loginUtils.getLoginEntrance());
                $this.QRS($this.getQR());
                $this.loginMethod(
                  loginUtils.getPriorityMax($this.loginEntrance())
                );
              },
            }
          );
        };
        $this.getQrCode = function () {
          return JSON.stringify(
            common.fetch("/auth/qr/login/generateQRCode", {
              type: "GET",
            }).data
          );
        };
        $this.loginBack = function (result, isAD) {
          if (result.data) {
            if (
              result.data.selectUserList &&
              result.data.selectUserList.length > 0
            ) {
              $this.userList(result.data.selectUserList);
              return false;
            }
            if (result.data.url) {
              common.redirectTo(result.data.url);
            } else if (result.data.needVerifyCode) {
              $this.isVerifyCodeVisible(true);
              $("img.verifyImg").attr(
                "src",
                "/auth/verification/img?type=" +
                  $this.verifyCodeType() +
                  "&random=" +
                  Math.random()
              );
            }
            if (
              result.data.message &&
              result.data.message.replace(/^\s+|\s+$/g, "")
            ) {
              if (isAD) {
                common.message("error", result.data.message);
              } else {
                common.errorAlert(result.data.message);
              }
            }
          } else if (result.message) {
            common.errorAlert(result.message);
          } else {
            common.errorAlert(_i18n("异常错误"));
          }
        };

        $this.openCode = function (key) {
          $this.baseUrl = $this.loginEntrance()[key].baseUrl;
          $this.url = $this.loginEntrance()[key].url;
          $this.loginMethod(key);
          // 刷新图形验证码
          $this.setVerifyCodeType();
        };
        if ($this.loginMethod().indexOf("QR") > -1) {
          $this.openCode($this.loginMethod());
        }
        $this.login = function () {
          console.log($("body").data("service"));
          var postD = $(".pwdLogin input").serializeObject();
          if (postD.verifyCode == "" && $this.isVerifyCodeVisible()) {
            common.message("error", _i18n("验证码必填"));
            return false;
          }
          var service = sessionStorage.getItem("service");
          var callBack = sessionStorage.getItem("callBack")
            ? sessionStorage.getItem("callBack")
            : "";
          if (service) {
            postD.service = service;
          }
          if (callBack) {
            postD.callBack = callBack;
          }
          if (postD.password) {
            var pwdType = { decryptType: "SM2", cryptKey: "" };
            try {
              pwdType.cryptKey =
                "04" + common.fetch("/auth/flow/login/getSm2PubK").data;
              postD.password = common.sm2.doCrypt(
                pwdType.cryptKey,
                postD.password
              );
            } catch (error) {}
            console.info("postD.password", pwdType);
          }
          var searchUrl = sessionStorage.getItem("searchUrl")
            ? sessionStorage.getItem("searchUrl")
            : "";
          console.log(postD);
          var ajaxUrl =
            $this.loginEntrance()[$this.loginMethod()].baseUrl +
            $this.loginEntrance()[$this.loginMethod()].url +
            "?" +
            searchUrl;
          common.fetch(ajaxUrl, {
            type: "POST",
            data: JSON.stringify(postD),
            handleError: function (data) {
              $("img.verifyImg").attr(
                "src",
                "/auth/verification/img?type=" +
                  $this.verifyCodeType() +
                  "&random=" +
                  Math.random()
              );
            },
            success: function (result) {
              console.log(result);
              $this.loginBack(result);
            },
          });
        };

        //微信校园版
        $this.wxFun = function (active) {
          //$this.loginMethod(active);
          var ajaxUrl =
            $this.loginEntrance()[active].baseUrl +
            $this.loginEntrance()[active].url;
          common.fetch(ajaxUrl, {
            type: "GET",
            query: {},
            success: function (result) {
              console.log(result);
              if (result.data) {
                window.location.href = result.data;
              }
            },
          });
        };

        //打开新标签页的登录
        $this.openUrlFun = function (active) {
          var ajaxUrl =
            $this.loginEntrance()[active].baseUrl +
            $this.loginEntrance()[active].url;
          common.fetch(ajaxUrl, {
            type: "GET",
            query: {},
            success: function (result) {
              console.log(result);
              if (result.redirect_uri) {
                window.location.href = result.redirect_uri;
              }
            },
          });
        };

        $this.larkCode = function () {};

        //window c端登录
        var loginAD = $this.loginEntrance().AD;
        if (loginAD) {
          var anonymous = loginAD.autoLogin;
          var spnego = sessionStorage.getItem("spnego");
          $this.enabled(anonymous);
          $this.spnegoLogin = function () {
            $.ajax({
              url: loginAD.baseUrl + loginAD.url,
              success: function (data) {
                console.log(data);
                common.redirectTo("/#/");
              },
              error: function (result) {
                console.log(result);
                sessionStorage.setItem("spnego", true);
                $this.loginBack(JSON.parse(result.responseText), true);
              },
            });
          };
          if (!spnego && $this.enabled()) {
            $this.spnegoLogin();
          }
        }

        // window cp
        cp();
      },
      template: require("./LoginTab.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/login/kingfa/Login.js
// module id = 124
// module chunks = 0